import { Reducer } from 'redux';
import { SYSTEM_SAVE_URL_SYS_OPTS, SystemActions } from 'redux/actions/system/types';
import { SystemState } from './types';

const initialState: SystemState = {
  urlSysOpts: []
};

export const systemReducer: Reducer<SystemState, SystemActions> = (state = initialState, action) => {
  switch (action.type) {
    case SYSTEM_SAVE_URL_SYS_OPTS: {
      return { ...state, urlSysOpts: action.payload.data };
    }
    default:
      return state;
  }
};
